export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4748.43e0c1e5.jpg";